import { useMutation, useQueryClient } from '@tanstack/react-query';
import { cityApi } from '../api/city.api';
import { cityKeys } from '../api/city.keys';
import toast from 'react-hot-toast';
import type { AxiosError } from 'axios';
import type { ApiErrorResponse, CityFormData } from '@/shared/types';

export function useCreateCity() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: CityFormData) => cityApi.create(data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: cityKeys.all });
      toast.success('City created');
    },
    onError: (err: AxiosError<ApiErrorResponse>) => {
      toast.error(err.response?.data?.message || 'Failed to create');
    },
  });
}

export function useUpdateCity() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: string | number; data: CityFormData }) =>
      cityApi.update(id, data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: cityKeys.all });
      toast.success('City updated');
    },
    onError: (err: AxiosError<ApiErrorResponse>) => {
      toast.error(err.response?.data?.message || 'Failed to update');
    },
  });
}

export function useDeleteCity() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string | number) => cityApi.delete(id),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: cityKeys.all });
      toast.success('City deleted');
    },
    onError: (err: AxiosError<ApiErrorResponse>) => {
      toast.error(err.response?.data?.message || 'Failed to delete');
    },
  });
}
